import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitaxiservice() {



    const cardData = {





keyword: "Navi Mumbai Taxi Service",

headingDescription: "Shreesha Tours & Travels offers professional Navi Mumbai Taxi Service for local travel, airport transfers, corporate transportation, business meetings, family vacations, outstation tours, one-way cab booking, round trips, wedding travel, and sightseeing. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Mini Bus, and premium vehicles to suit every travel requirement. With experienced drivers, clean and well-maintained vehicles, transparent pricing, doorstep pickup and drop, flexible booking options, and 24/7 customer support, we ensure a safe, comfortable, and hassle-free travel experience. Whether you need a taxi for business, leisure, pilgrimage, airport pickup, or long-distance travel, Shreesha Tours & Travels delivers dependable Navi Mumbai taxi booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Navi Mumbai to Matheran",
    description: "Matheran is a beautiful hill station famous for its toy train, Panorama Point, Charlotte Lake, Echo Point, and pollution-free environment, making it a popular weekend getaway."
  },
  {
    title: "Navi Mumbai to Alibaug",
    description: "Alibaug is a coastal destination known for Kolaba Fort, Varsoli Beach, Alibaug Beach, water sports, and luxurious beach resorts."
  },
  {
    title: "Navi Mumbai to Igatpuri",
    description: "Igatpuri is a scenic hill destination renowned for Vipassana International Academy, Camel Valley, waterfalls, trekking trails, and lush greenery."
  },
  {
    title: "Navi Mumbai to Bhandardara",
    description: "Bhandardara is a peaceful nature destination featuring Arthur Lake, Randha Waterfall, Wilson Dam, and beautiful Sahyadri mountain views."
  },
  {
    title: "Navi Mumbai to Harihareshwar",
    description: "Harihareshwar is a popular Konkan beach destination known for Harihareshwar Temple, scenic coastline, peaceful beaches, and coastal drives."
  },
  {
    title: "Navi Mumbai to Tarkarli",
    description: "Tarkarli is famous for its crystal-clear beaches, scuba diving, snorkeling, Sindhudurg Fort, and exciting water sports activities."
  },
  {
    title: "Navi Mumbai to Kaas Plateau",
    description: "Kaas Plateau, a UNESCO World Natural Heritage Site, is known for its spectacular seasonal wildflowers, scenic landscapes, and nature photography."
  },
  {
    title: "Navi Mumbai to Amboli",
    description: "Amboli is a picturesque hill station offering waterfalls, mist-covered valleys, lush forests, trekking trails, and pleasant weather throughout the year."
  },
  {
    title: "Navi Mumbai to Ganpatipule",
    description: "Ganpatipule is one of Maharashtra's most famous beach and pilgrimage destinations, known for the Swayambhu Ganpati Temple and beautiful Konkan coastline."
  },
  {
    title: "Navi Mumbai to Solapur",
    description: "Solapur is a popular destination for Siddheshwar Temple, Akkalkot Swami Samarth Temple, Pandharpur pilgrimage, and business travel."
  }
],


"services": [
  {
    "name": "Navi Mumbai Taxi Service",
    "description": "Book Navi Mumbai Taxi Service for safe, comfortable, and affordable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, Sedan, SUV, Tempo Traveller, and luxury cabs for local, airport, corporate, family, and outstation travel."
  },
  {
    "name": "Cab Service in Navi Mumbai",
    "description": "Choose Cab Service in Navi Mumbai for reliable local and outstation transportation with experienced drivers, transparent pricing, clean vehicles, and 24x7 availability."
  },
  {
    "name": "Taxi Service in Navi Mumbai",
    "description": "Reserve Taxi Service in Navi Mumbai for comfortable travel with professional chauffeurs, punctual pickups, and premium AC vehicles for every journey."
  },
  {
    "name": "Navi Mumbai Taxi",
    "description": "Book Navi Mumbai Taxi for local rides, airport transfers, business travel, family outings, and long-distance trips with dependable chauffeur-driven vehicles."
  },
  {
    "name": "Taxi in Navi Mumbai",
    "description": "Hire Taxi in Navi Mumbai for quick and convenient transportation with clean AC vehicles, verified drivers, and affordable fares."
  },
  {
    "name": "Navi Mumbai Cab Service",
    "description": "Choose Navi Mumbai Cab Service for one-way, round-trip, airport, corporate, and sightseeing travel with multiple vehicle options and experienced chauffeurs."
  },
  {
    "name": "Vashi Taxi Service",
    "description": "Book Vashi Taxi Service for local travel, airport pickup and drop, office transfers, and outstation journeys with reliable drivers and comfortable vehicles."
  },
  {
    "name": "Nerul Taxi Service",
    "description": "Reserve Nerul Taxi Service for affordable and reliable transportation with professional chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Belapur Taxi Service",
    "description": "Choose Belapur Taxi Service for comfortable local and outstation travel with experienced drivers, transparent pricing, and quality service."
  },
  {
    "name": "Kharghar Taxi Service",
    "description": "Book Kharghar Taxi Service for airport transfers, family travel, business trips, and outstation rides with clean vehicles and courteous chauffeurs."
  },
  {
    "name": "Panvel Taxi Service",
    "description": "Reserve Panvel Taxi Service for dependable transportation with premium vehicles, experienced drivers, and affordable travel packages."
  },
  {
    "name": "Online Taxi Booking Navi Mumbai",
    "description": "Book Online Taxi Booking Navi Mumbai with instant confirmation, secure reservations, multiple vehicle choices, and 24x7 customer support."
  },
  {
    "name": "Book Taxi Service in Navi Mumbai",
    "description": "Choose Book Taxi Service in Navi Mumbai for quick online reservations, transparent pricing, and professional chauffeur-driven travel."
  },
  {
    "name": "Best Taxi Service in Navi Mumbai",
    "description": "Reserve the Best Taxi Service in Navi Mumbai for premium travel with experienced chauffeurs, sanitized vehicles, punctual service, and excellent customer support."
  },
  {
    "name": "Cheapest Taxi Service in Navi Mumbai",
    "description": "Book the Cheapest Taxi Service in Navi Mumbai with affordable fares, clean AC vehicles, reliable drivers, and comfortable transportation."
  },
  {
    "name": "24x7 Taxi Service in Navi Mumbai",
    "description": "Choose 24x7 Taxi Service in Navi Mumbai for round-the-clock local, airport, corporate, and outstation travel with professional chauffeurs."
  },
  {
    "name": "Navi Mumbai Airport Taxi Service",
    "description": "Book Navi Mumbai Airport Taxi Service for punctual airport pickup and drop with flight tracking, luggage assistance, and premium AC vehicles."
  },
  {
    "name": "Airport Taxi Navi Mumbai",
    "description": "Reserve Airport Taxi Navi Mumbai for hassle-free airport transfers with experienced chauffeurs, comfortable vehicles, and dependable service."
  },
  {
    "name": "Innova Crysta Navi Mumbai Taxi Service",
    "description": "Choose Innova Crysta Navi Mumbai Taxi Service for luxury travel with premium interiors, spacious seating, and professional chauffeur service."
  },
  {
    "name": "Innova Cab Navi Mumbai Taxi Service",
    "description": "Book Innova Cab Navi Mumbai Taxi Service for family trips, airport transfers, and outstation travel with spacious seating and extra luggage capacity."
  },
  {
    "name": "Ertiga Cab Navi Mumbai Taxi Service",
    "description": "Reserve Ertiga Cab Navi Mumbai Taxi Service for affordable family transportation with comfortable seating, clean AC vehicles, and experienced drivers."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai Taxi Service",
    "description": "Choose Swift Dzire Cab Navi Mumbai Taxi Service for economical travel with comfortable sedan vehicles, professional chauffeurs, and reliable service."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai Taxi Service",
    "description": "Book Kia Carens Cab Navi Mumbai Taxi Service for premium family travel with spacious interiors, comfortable seating, and smooth chauffeur-driven rides."
  },
  {
    "name": "Sedan Cab Navi Mumbai Taxi Service",
    "description": "Reserve Sedan Cab Navi Mumbai Taxi Service for affordable local, airport, and outstation transportation with clean AC sedans and experienced drivers."
  },
  {
    "name": "SUV Cab Navi Mumbai Taxi Service",
    "description": "Choose SUV Cab Navi Mumbai Taxi Service for spacious travel with extra luggage capacity, premium comfort, and dependable chauffeur-driven transportation."
  },
  {
    "name": "Hyundai Aura Cab Navi Mumbai Taxi Service",
    "description": "Book Hyundai Aura Cab Navi Mumbai Taxi Service for budget-friendly city rides, airport transfers, and outstation travel with clean AC vehicles and professional chauffeurs."
  }
],
"tableData": [
  ["Navi Mumbai Taxi Service", "Cab Service in Navi Mumbai"],
  ["Taxi Service in Navi Mumbai", "Navi Mumbai Taxi"],
  ["Taxi in Navi Mumbai", "Navi Mumbai Cab Service"],
  ["Vashi Taxi Service", "Nerul Taxi Service"],
  ["Belapur Taxi Service", "Kharghar Taxi Service"],
  ["Panvel Taxi Service", "Online Taxi Booking Navi Mumbai"],
  ["Book Taxi Service in Navi Mumbai", "Best Taxi Service in Navi Mumbai"],
  ["Cheapest Taxi Service in Navi Mumbai", "24x7 Taxi Service in Navi Mumbai"],
  ["Navi Mumbai Airport Taxi Service", "Airport Taxi Navi Mumbai"],
  ["Innova Crysta Navi Mumbai Taxi Service", "Innova Cab Navi Mumbai Taxi Service"],
  ["Ertiga Cab Navi Mumbai Taxi Service", "Swift Dzire Cab Navi Mumbai Taxi Service"],
  ["Kia Carens Cab Navi Mumbai Taxi Service", "Sedan Cab Navi Mumbai Taxi Service"],
  ["SUV Cab Navi Mumbai Taxi Service", "Hyundai Aura Cab Navi Mumbai Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Taxi Service",
    WhyChoosedescription: "Shreesha Travels offers dependable Navi Mumbai taxi services for local travel, airport transfers, corporate transportation, outstation trips, sightseeing tours, family travel, and business requirements. Enjoy comfortable rides with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Travel Anywhere with Private Chauffeur-Driven Cabs",
    WhyChoosedescription: "Whether you need a cab within Navi Mumbai or to destinations across Maharashtra and India, our taxi service provides convenient door-to-door transportation with flexible booking options."
  },
  {
    WhyChooseheading: "Large Fleet for Every Travel Requirement",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles suitable for individuals, families, and corporate groups."
  },
  {
    WhyChooseheading: "Suitable for Local, Airport & Outstation Travel",
    WhyChoosedescription: "Our Navi Mumbai taxi service is ideal for Mumbai Airport transfers, Navi Mumbai Airport transfers, office commutes, hotel transfers, weddings, pilgrimage tours, weekend getaways, and long-distance journeys."
  },
  {
    WhyChooseheading: "Flexible One-Way, Round Trip & Rental Packages",
    WhyChoosedescription: "Book one-way taxis, round-trip cabs, hourly rentals, full-day packages, or customized travel plans according to your schedule and destination."
  },
  {
    WhyChooseheading: "Experienced Drivers with Excellent Route Knowledge",
    WhyChoosedescription: "Our courteous chauffeurs are familiar with Navi Mumbai, Mumbai, expressways, and interstate highways, ensuring punctual service, safe driving, and a comfortable journey."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Well-Maintained Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and thoroughly inspected before every trip to provide passengers with a safe and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Taxi Service with Shreesha Travels",
    WhyChoosedescription: "Experience transparent pricing, instant booking support, reliable chauffeur service, and comfortable transportation for every local and outstation journey from Navi Mumbai."
  }
]

};

const faqData = [
  {
    question: "What types of taxi services do you provide in Navi Mumbai?",
    answer: "We provide local taxi services, airport transfers, outstation cabs, corporate transportation, sightseeing tours, wedding travel, and chauffeur-driven car rentals."
  },
  {
    question: "Can I book a one-way taxi from Navi Mumbai?",
    answer: "Yes, one-way taxi bookings are available for local as well as outstation destinations."
  },
  {
    question: "Which vehicles are available in Navi Mumbai Taxi Service?",
    answer: "We offer Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
  },
  {
    question: "Do you provide airport taxi service from Navi Mumbai?",
    answer: "Yes, we offer airport transfers to and from Mumbai Airport, Navi Mumbai Airport, and other nearby airports."
  },
  {
    question: "Can I hire a taxi for full-day travel?",
    answer: "Yes, full-day taxi rentals and hourly packages are available for business meetings, sightseeing, personal travel, and family outings."
  },
  {
    question: "Is your Navi Mumbai taxi service available 24x7?",
    answer: "Yes, our taxi services operate throughout the day and night based on advance and scheduled bookings."
  },
  {
    question: "Do you provide taxis for corporate clients?",
    answer: "Yes, our services include employee transportation, executive travel, client pickups, business meetings, and corporate events."
  },
  {
    question: "How is the Navi Mumbai taxi fare calculated?",
    answer: "The fare depends on the vehicle category, travel distance, trip duration, route, toll charges, parking fees, and selected package."
  },
  {
    question: "Can I book a taxi for outstation travel from Navi Mumbai?",
    answer: "Yes, we provide outstation taxi services to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Gujarat, and many other destinations."
  },
  {
    question: "How can I book Navi Mumbai Taxi Service with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Deepak Shah",
    feedback: "Excellent taxi service in Navi Mumbai. The booking process was simple, the driver arrived on time, and the vehicle was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sonal Deshmukh",
    feedback: "We regularly book cabs with Shreesha Travels for airport and outstation trips. Their service is reliable, professional, and always punctual.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Taxi Service",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-taxi-service.webp",
  "description":
    "Book Navi Mumbai Taxi Service with Shreesha Tours & Travels for safe, comfortable, and reliable taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, airport transfers, outstation trips, family tours, business travel, sightseeing, and long-distance journeys in Navi Mumbai with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-taxi-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Navi Mumbai Taxi Service | Cab Booking Navi Mumbai | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Taxi Service with Shreesha Travels for safe and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, airport transfers, outstation trips, family tours, corporate travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai Taxi Service, Cab Service in Navi Mumbai, Navi Mumbai Taxi, Taxi in Navi Mumbai, Navi Mumbai Cab Booking, Navi Mumbai Local Taxi Service, Navi Mumbai Airport Taxi, Navi Mumbai Outstation Cab, Navi Mumbai Car Rental, Best Taxi Service Navi Mumbai, Online Taxi Booking Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitaxiservice;